<template>
    <div class="container-scroller">
        <vue-progress-bar></vue-progress-bar>
        <dashboard-navbar></dashboard-navbar>
        <div class="container-fluid page-body-wrapper">
            <dashboard-sidebar></dashboard-sidebar>

            <div class="main-panel">
                <div class="content-wrapper vld-parent" v-if="$store.getters.isAuthenticated">
                    <loading-indicator :sync="$store.getters.shouldLoadContent" :full-page="false"></loading-indicator>

                    <div class="alert alert-info shadow-sm" v-if="($route.name !== 'start-subscription' && $route.name !== 'subscription' && $route.name.substr(0, 5) !== 'admin') && !$store.getters.isSubscribed">
                        <h3 class="title">
                            {{ $t('messages.not_subscribed.title') }}
                        </h3>
                        <p>
                            {{ $t('messages.not_subscribed.message') }}
                        </p>
                        <router-link :to="{name: 'start-subscription'}" tag="button" class="btn btn-outline-dark">
                            {{ $t('messages.not_subscribed.subscribe_now_link') }}
                        </router-link>
                    </div>

                    <livestream-alert v-if="$store.getters.isSubscribed"></livestream-alert>

                    <transition name="component-fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                    <dashboard-footer></dashboard-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardNavbar from "./partials/DashboardNavbar";
import DashboardSidebar from "./partials/DashboardSidebar";
import DashboardFooter from "./partials/DashboardFooter";
import LoadingIndicator from "../../components/Includes/LoadingIndicator";
import BackendSyncRepository from "../../repositories/BackendSyncRepository";
import LivestreamAlert from "../../components/Includes/LivestreamAlert";
export default {
    name: "DashboardLayout",
    components: {LivestreamAlert, LoadingIndicator, DashboardFooter, DashboardSidebar, DashboardNavbar},
    data: () => ({
        i18nDebug: false,
        syncInterval: null,
    }),
    created() {
        this.syncInterval = setInterval(() => {
            BackendSyncRepository.syncData();
        }, 15000);
    },
    beforeDestroy() {
        clearInterval(this.syncInterval);
    }
}
</script>
